// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LayoutSingUp_wrapper__65Fgt","main":"LayoutSingUp_main__31g_M","timerWrapper":"LayoutSingUp_timerWrapper__2q7xv"};